import React, { useState, useEffect } from 'react';
import Button from '../../../../../ui/canon/Button';
import Input from '../../../../../ui/canon/Input';
import { SendIcon } from 'lucide-react';

const ContactWidget = ({ onAnswer, disabled, initialValue = null }) => {
  const getInitialContact = () => {
    if (initialValue && typeof initialValue === 'object') {
      return { 
        name: initialValue.name || '', 
        email: initialValue.email || '', 
        role: initialValue.role || '' 
      };
    }
    return { name: '', email: '', role: '' };
  };

  const [contact, setContact] = useState(getInitialContact);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    setContact(getInitialContact());
    setIsSubmitting(false);
  }, [initialValue]);

  const handleSubmit = () => {
    if (contact.name && contact.email && !isSubmitting) {
      setIsSubmitting(true);
      onAnswer({ value: contact });
    }
  };

  return (
    <div className="space-y-3">
      <Input
        placeholder="Name"
        value={contact.name}
        onChange={(e) => setContact({...contact, name: e.target.value})}
        disabled={disabled || isSubmitting}
      />
      <Input
        placeholder="Email"
        type="email"
        value={contact.email}
        onChange={(e) => setContact({...contact, email: e.target.value})}
        disabled={disabled || isSubmitting}
      />
      <Input
        placeholder="Role (Optional)"
        value={contact.role}
        onChange={(e) => setContact({...contact, role: e.target.value})}
        disabled={disabled || isSubmitting}
      />
      <Button
        onClick={handleSubmit}
        disabled={!contact.name || !contact.email || disabled || isSubmitting}
        className="w-full"
      >
        <SendIcon className="h-4 w-4 mr-2" />
        Submit Contact
      </Button>
    </div>
  );
};

export default ContactWidget;
